import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import { useQuery } from '@apollo/client';
import useMedia from 'use-media';

import { theme } from '@notino/react-styleguide';
import {
  GetSectionsAvailabilityQuery,
  GetSectionsAvailabilityQueryVariables,
} from '@notino/shared/definitions/types';

import { Divider } from '@components/Divider';
import RoutineContent from '@components/Universals/Routine/RoutineContent';
import {
  Container,
  MarginWrapper,
  RoutineWrapper,
  Placeholder,
} from '@components/Universals/Routine/styled';
import getSectionsAvailabilityQuery from '@containers/ProductDetailContainer/queries/sectionsAvailability.graphql';

export const MAX_MEDIUM_BREAKPOINT = `(max-width:${theme.breakpoints.md}rem)`;

export interface IRoutineProps {
  productId: string;
  showDivider?: boolean;
}
const Routine: React.FC<IRoutineProps> = ({
  productId,
  showDivider = true,
}) => {
  const isMobile = useMedia(MAX_MEDIUM_BREAKPOINT);
  const { data, error, loading } = useQuery<
    GetSectionsAvailabilityQuery,
    GetSectionsAvailabilityQueryVariables
  >(getSectionsAvailabilityQuery, {
    variables: {
      productId,
    },
    errorPolicy: 'all',
    ssr: false,
    skip: isMobile,
  });

  const [ref, inView] = useInView({ triggerOnce: true });

  if (
    error ||
    loading ||
    !data?.RoutineByProductId?.available ||
    !data?.RoutineByProductId?.routine ||
    isMobile
  ) {
    return null;
  }

  return (
    <Container data-testid="routine-container">
      <MarginWrapper>
        {showDivider && <Divider />}
        <div ref={ref}>
          {inView ? (
            <RoutineWrapper>
              <RoutineContent
                routine={data.RoutineByProductId.routine}
                items={data.RoutineByProductId.routine.items.map((item) =>
                  String(item.productId)
                )}
              />
            </RoutineWrapper>
          ) : (
            <Placeholder />
          )}
        </div>
      </MarginWrapper>
    </Container>
  );
};

export default Routine;
